// Registro de presença (com fallback offline via fila no localStorage)
import { collection, doc, setDoc, getDocs, query, where } from "firebase/firestore";
import type { Student } from '../types';
import { db, periodBase, OFFLINE_MODE_ENABLED } from './config';

export async function recordAttendance(pid: string, student: Student, sessionId: string, isOnline: boolean = navigator.onLine) {
  if (!isOnline && OFFLINE_MODE_ENABLED) {
    const newItem = { queueId: Date.now() + '_' + Math.random().toString(36).slice(2,9), studentId:student.id, studentName:student.name, dre:student.dre, turma:student.turma, sessionId, timestamp:new Date().toISOString(), periodId:pid };
    const currentRaw = localStorage.getItem('gf_att_queue') || '[]';
    let currentQueue: any[] = [];
    try { currentQueue = JSON.parse(currentRaw); } catch(e) { currentQueue = []; }
    const alreadyQueued = currentQueue.some((q: any) => q.studentId === student.id && q.sessionId === sessionId);
    if (alreadyQueued) throw new Error('Presença já registada nesta sessão.');
    currentQueue.push(newItem);
    localStorage.setItem('gf_att_queue', JSON.stringify(currentQueue));
    return;
  }
  else if (!isOnline) { throw new Error("Sem internet. Peça à professora para registrar presença manual."); }
  const attRef = collection(db, periodBase(pid) + '/attendance');
  const snapSession = await getDocs(query(attRef, where('studentId','==',student.id), where('sessionId','==',sessionId)));
  if (!snapSession.empty) throw new Error('Presença já registada nesta sessão.');

  const attDocId = (student.id + '_' + sessionId).replace(/\//g, '_');
  await setDoc(doc(attRef, attDocId), { studentId: student.id, studentName: student.name, dre: student.dre, turma: student.turma, sessionId, timestamp: new Date(), periodId: pid });
}
